"use strict";

var curry = require("./curry.js");

module.exports = curry(function defaultTo(a, b) {
  return b == null || Number.isNaN(b) ? a : b;
});